export default class Filter {
    constructor() {
        this.init()
    }

    init() {
        let postList = document.querySelectorAll('[data-elem="postList"]');

        if( postList.length ) {
            postList.forEach((list) => {
                this.prepareClickHandlers(list);
            });
        }
    }

    prepareClickHandlers(list) {
        let categories = list.querySelectorAll('[data-elem="postListCategory"]');
        let container = list.querySelector('[data-elem="postListContainer"]');

        if( categories.length ) {
            categories.forEach((btn) => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    let newVal = btn.getAttribute('data-active') == 0 ? 1 : 0;
                    btn.setAttribute('data-active', newVal);

                    let filters = this.getPostFilters(list);
                        filters.paged = 1;
                        filters.clearList = 1;

                    this.getPosts(filters, container, list);
                });
            });
        }

        this.preparePaginationHandlers(list);
        this.prepareShowMorePostsHandlers(list);
    }

    preparePaginationHandlers(list) {
        let pagination = list.querySelector('[data-elem="postListPagination"]');
        let container = list.querySelector('[data-elem="postListContainer"]');

        if( pagination ) {
            let links = pagination.querySelectorAll('a');

            if( links.length ) {
                links.forEach((link) => {
                    link.addEventListener('click', (e) => {
                        e.preventDefault();

                        let url_string = link.getAttribute('href');

                        //Just to get it working on local env with file watcher.
                        if (!url_string.includes('http') ) {
                            url_string = 'http:' + url_string;
                        }

                        let url = new URL(url_string);
                        let page_no = url.searchParams.get("paged");
                        let filters = this.getPostFilters(list);
                            filters.paged = page_no;

                        this.getPosts(filters, container, list);
                    })
                });
            }
        }
    }

    prepareShowMorePostsHandlers(list) {
        let showMore = list.querySelector('[data-elem="postListMore"]');
        let container = list.querySelector('[data-elem="postListContainer"]');

        if (showMore) {

            showMore.addEventListener('click', () => {
                let page_no = showMore.getAttribute('data-page');
                let filters = this.getPostFilters(list);
                filters.paged = page_no;

                this.getPosts(filters, container, list);

                // let loader = document.createElement('div');
                // loader.innerHTML = this.getLoaderHtml();
                // showMore.appendChild(loader);
                showMore.style.pointerEvents = 'none';
            });

        }
    }


    getPostFilters(list) {
        let obj = {};
        let categories = list.querySelectorAll('[data-elem="postListCategory"][data-active="1"]');
        let postsPerPage = list.getAttribute('data-postsPerPage');
        let showPagination = list.getAttribute('data-pagination');
        let showMore = list.getAttribute('data-showMore');
        let postTemplate = list.getAttribute('data-postTemplate');
        let postIn = list.getAttribute('data-postIn');
        let postNotIn = list.getAttribute('data-postNotIn');

        if (categories.length ) {
            let values = [];
            categories.forEach(function(category) {
                values.push(category.getAttribute('data-id'));
            });
            obj.categories = values;
        }

        obj.postsPerPage = postsPerPage;
        obj.showPagination = showPagination;
        obj.showMore = showMore;
        obj.postTemplate = postTemplate;
        obj.postIn = postIn;
        obj.postNotIn = postNotIn;
        obj.action = 'postList';

        return obj;
    }


    getPosts(filters, container, list) {
        let context = this;
        let ajaxUrl = php_vars.ajaxUrl;

        jQuery.ajax({
            type : 'post',
            url : ajaxUrl,
            data: filters,
            beforeSend: function() {
                if ( !filters.showMore || (filters.clearList && filters.clearList == 1) ) {
                    container.innerHTML = context.getLoaderHtml();

                    const navbarHeight = document.querySelector('.navbar') ? document.querySelector('.navbar').offsetHeight : 0;
                    $('html, body').animate({
                        scrollTop: $(container).parent().offset().top - navbarHeight - 50
                    }, 500);
                } else {
                    let showMore = list.querySelector('[data-elem="postListMore"]');

                    if( showMore ) {
                        showMore.style.opacity = 0.5;
                    }
                }
            },
            error: function( error ) {
                console.log(error);
            },
            success : function( response ) {
                if (filters.showMore) {
                    let showMore = list.querySelector('[data-elem="postListMore"]');

                    if( showMore ) {
                        showMore.remove();
                    }
                }
                if (document.getElementById('loader')) {
                    document.getElementById('loader').remove();
                }
                container.innerHTML += response;
                context.preparePaginationHandlers(list);
                context.prepareShowMorePostsHandlers(list);
            }
        });
    }

    getLoaderHtml() {
        return '<div id="loader" class="loader"><div class="loader__spinner"><div></div><div></div><div></div><div></div></div></div>';
    }


}


//////////////////
// WEBPACK FOOTER
// ./js/components/filter.js
// module id = 19
// module chunks = 0